import { exportPDF } from '../utils/pdfExport';
import { TarjetaRegistro } from './TarjetaRegistro';

// ── OPERARIO: HISTORIAL ──────────────────────────────────────────
export const HistorialSection = ({ historial, loading, cargarHistorial }) => (
  <div className="space-y-3">
    <div className="flex items-center justify-between">
      <h2 className="font-bold text-gray-800">📋 Pendientes de validar</h2>
      <div className="flex gap-2 items-center">
        <span className="text-xs text-gray-500">{historial.length} pendientes</span>
        <button onClick={() => cargarHistorial()} className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded-lg border border-blue-200">🔄 Actualizar</button>
      </div>
    </div>
    {loading && <div className="bg-white rounded-xl shadow p-6 text-center text-gray-400 text-sm">⏳ Cargando...</div>}
    {!loading && historial.length === 0 && <div className="bg-white rounded-xl shadow p-8 text-center text-gray-400"><p className="text-4xl mb-2">✅</p><p className="text-sm">No hay formularios pendientes.</p></div>}
    {historial.map(r => (
      <TarjetaRegistro key={r.id} r={r} esAdmin={false} onExport={exportPDF} />
    ))}
  </div>
);
